import { FE_SESSION_ID_KEY } from 'constants/session';
import { recordSignUpMetric } from 'lib/metrics';
import type { SignUpStep, SignUpStepName } from 'models/metric';
import {
    getLocalStorageItem,
    getSessionStorageItem,
    removeSessionStorageItem,
    setSessionStorageItem,
} from 'utils/storage';
import { uuidv4 } from 'utils/uuid';

const KYC_FLOW_ID_KEY = 'kalshi-kyc-flow-id';

export type KycTrackingContext = Omit<SignUpStep, 'step' | 'has_referral' | 'referral_code'>;

export function ensureKycFlowId(): string {
    const existing = getSessionStorageItem(KYC_FLOW_ID_KEY);
    if (existing) {
        return existing;
    }

    const kycFlowId = uuidv4();
    setSessionStorageItem(KYC_FLOW_ID_KEY, kycFlowId);
    return kycFlowId;
}

export function clearKycFlowId(): void {
    removeSessionStorageItem(KYC_FLOW_ID_KEY);
}

function getFrontendSessionId(): string | undefined {
    return getLocalStorageItem(FE_SESSION_ID_KEY) || undefined;
}

export function trackKycStep(step: SignUpStepName, context: KycTrackingContext = {}): void {
    recordSignUpMetric({
        step,
        kyc_flow_id: ensureKycFlowId(),
        frontend_session_id: getFrontendSessionId(),
        surface: 'signup',
        ...context,
    });
}
